import React from "react";
import "./Key_Elements.css";
import Common_Title from "../../../common_components/common_title/Common_Title";

const Key_Elements = ({ imgSrc1, imgSrc2, boxText, subText,keyElements }) => {
  return (
    <section className="Key_Elements">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-5 col-sm-6 col-10">
            <div className="left_side">
              <div className="img1_div">
                <img src={imgSrc1} className="inner_img" />
              </div>
              <div className="img2_div">
                <img src={imgSrc2} className="inner_img" />
              </div>
            </div>
          </div>
          <div className="col-lg-7">
            <div className="right_side">
              <Common_Title
                boxText={boxText}
                subText={subText}
              />

                <div className="key_elements_div">
                    <div className="elemnts_holder">
                        {keyElements?.map((item) => {
                            return(
                                <div className="elemnt_div">
                                    <img src="/assets/images/services/key_elements/checked.png" className="point_img"/>
                                    <p className="point_text">{item}</p>
                                </div>
                            )
                        })}
                    </div>
                </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Key_Elements;
